module.exports = __webpack_public_path__ + "static/2_3_game-tree-4_LV-0bd1ffb847714dfbf2b90a54287f2b61.svg";